import { formatAttributeKey } from './formatAttributeKey.js';

export const getLexicalArgKeys = (argValue) => {
  const values = [];

  const recurse = (children) => {
    children.forEach((child) => {
      if (child.type === 'text') {
        values.push({ type: 'text', value: child.text });
      } else if (child.type === 'block') {
        const { key, stepId, stepNumber } = child.data;
        const pattern = /^response\[\d+\]\./;
        const cleanedKey = key.replace(pattern, '');
        values.push({ type: 'block', value: formatAttributeKey(cleanedKey), key: cleanedKey, stepId, stepNumber });
      } else if (child.children) {
        recurse(child.children);
      }
    });
  };

  const rootChildren = argValue?.root?.children || [];
  rootChildren.forEach((n) => {
    if (n.type === 'paragraph' && n.children) {
      recurse(n.children);
    }
  });

  return values;
};
